@if (applianceInfo) {
<div class="appliance-status-page app-page-stack">
    <app-section-card title="Appliance Version Information" icon="pi pi-server" [flush]="true">
        <p-table [value]="versionRowPairs()" [rowHover]="true" class="appliance-version-table">
            <ng-template #header>
                <tr>
                    <th>Component</th>
                    <th>Version / Value</th>
                    <th>Component</th>
                    <th>Version / Value</th>
                </tr>
            </ng-template>
            <ng-template #body let-row>
                <tr>
                    <td class="label-cell version-label-cell">{{ row.left.label }}</td>
                    <td class="monospace version-value-cell">{{ row.left.value }}</td>
                    <td class="label-cell version-label-cell">{{ row.right?.label ?? '—' }}</td>
                    <td class="monospace version-value-cell">{{ row.right?.value ?? '—' }}</td>
                </tr>
            </ng-template>
        </p-table>
    </app-section-card>

    @if (networkInterfaces().length > 0) {
    <app-section-card title="Network Interfaces" icon="pi pi-wifi" [count]="networkInterfaces().length" [flush]="true">
        <p-table [value]="networkInterfaces()" [rowHover]="true" [scrollable]="true">
            <ng-template #header>
                <tr>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Status</th>
                    <th>MAC Address</th>
                    <th>IP Address(es)</th>
                    <th>Gateway</th>
                    <th>DNS</th>
                    <th>Speed</th>
                </tr>
            </ng-template>
            <ng-template #body let-iface>
                <tr>
                    <td class="monospace">{{ iface.name }}</td>
                    <td [pTooltip]="interfaceTypeTooltip(iface.networkInterfaceType)" tooltipPosition="top">{{ formatInterfaceType(iface.networkInterfaceType) }}</td>
                    <td>
                        <p-tag [value]="formatOperationalStatus(iface.operationalStatus)" [severity]="operationalStatusSeverity(iface.operationalStatus)" />
                    </td>
                    <td class="monospace">{{ formatMacAddress(iface.macAddress) }}</td>
                    <td class="monospace">{{ formatAddresses(iface.unicastAddresses) }}</td>
                    <td class="monospace">{{ formatAddresses(iface.gatewayAddresses) }}</td>
                    <td class="monospace">{{ formatAddresses(iface.dnsAddresses) }}</td>
                    <td>{{ formatSpeed(iface.speed) }}</td>
                </tr>
            </ng-template>
        </p-table>
    </app-section-card>
    } @if (routingTable().length > 0) {
    <app-section-card title="Routing Table" icon="pi pi-arrow-right-arrow-left" [count]="routingTable().length" [flush]="true">
        <p-table [value]="routingTable()" [rowHover]="true" [scrollable]="true">
            <ng-template #header>
                <tr>
                    <th>Interface</th>
                    <th>Destination</th>
                    <th>Gateway</th>
                    <th>Mask</th>
                    <th>Flags</th>
                    <th>Metric</th>
                </tr>
            </ng-template>
            <ng-template #body let-route>
                <tr [class.default-route]="route.isDefault">
                    <td class="monospace">{{ route.iface }}</td>
                    <td class="monospace">
                        {{ route.destination }} @if (route.isDefault) {
                        <span class="default-badge">default</span>
                        }
                    </td>
                    <td class="monospace">{{ route.gateway === '0.0.0.0' ? '—' : route.gateway }}</td>
                    <td class="monospace">{{ route.mask }}</td>
                    <td>
                        <span class="flags-text" [pTooltip]="flagsTooltip(route.flags)" tooltipPosition="top"> {{ route.flags }} </span>
                    </td>
                    <td>{{ route.metric }}</td>
                </tr>
            </ng-template>
        </p-table>
    </app-section-card>
    }
</div>
} @else {
<p-message severity="info" class="w-full mt-4">No appliance information available. This data is collected during device check-in and is only available for hardware processors.</p-message>
}
